
// Base URL for the API. Change this to your actual API URL when available.
const API_BASE_URL = "https://api.yourdomain.com";

/**
 * Submits the contact form data to the server.
 * @param {Object} data - The form data (e.g., { name, email, phone, message }).
 * @returns {Promise<Object>} - The response data.
 */
export const submitContactForm = async (data) => {
    try {
        // Replace with your actual API endpoint
        const response = await fetch(`${API_BASE_URL}/contact`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Failed to submit contact form:", error);
        throw error;
    }
};

/**
 * Fetches the list of testimonials from the server.
 * @returns {Promise<Array>} - The list of testimonials.
 */
export const fetchTestimonials = async () => {
    try {
        // Replace with your actual API endpoint
        const response = await fetch(`${API_BASE_URL}/testimonials`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Failed to fetch testimonials:", error);
        throw error;
    }
};
